import { render } from "./ResultsMobilenew.vue?vue&type=template&id=bcbe7e6a&scoped=true"
import script from "./ResultsMobilenew.vue?vue&type=script&lang=js"
export * from "./ResultsMobilenew.vue?vue&type=script&lang=js"

import "./ResultsMobilenew.vue?vue&type=style&index=0&id=bcbe7e6a&lang=scss"
import "./ResultsMobilenew.vue?vue&type=style&index=1&id=bcbe7e6a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2682924403/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcbe7e6a"]])

export default __exports__